module.exports = __webpack_public_path__ + "static/media/boy-4.eb9dcc6a.svg";